<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="03" :question="question" :comment="comment" :modalActivator="modalActivator" @activateModal="modalActive=true"></QuestionTitle>
        <div class="container-70">
            <AccordeonBox :headerText="headerText" :bodyText="bodyText"></AccordeonBox>
            <div v-if="result!=null" @click="saveAndContinue('citoyenTransport', JSON.stringify(result), './question-3')" class="btn-primary d-block w-100 mt-50px text-center" >Suivant</div>
            <AvancementLine percent="33%" class="mt-50px"></AvancementLine>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import AccordeonBox from '@/components/AccordeonBox.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            modalActive:false,
            question:'Indiquez les distances parcourues lors des voyages personnels effectués dans la dernière année par votre ménage.',
            comment:'Par exemples : vacances, études, humanitaire, visite de la famille à l\'étranger.',
            headerText:'Besoin d’aide pour faire votre choix?',
            bodyText: 'Les voyages d\'affaires devraient être pris en charge par votre employeur.</br>Pour les voyages en avion, vous pouvez calculez la distance à vol d\'oiseaux sur ce site : Distance.to'
        }
    },
    components: {
        QuestionTitle,
        AvancementLine,
        AccordeonBox,
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('citoyenTransport')){
            this.result=JSON.parse(sessionStorage.getItem('citoyenTransport'))
        }
    }
}
</script>